"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputBaseStyles = void 0;

var _styledComponents = require("styled-components");

var _styleHelpers = require("../styleHelpers");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var filledVariantStyle = {
  borderColor: (0, _styleHelpers.getColor)('borders'),
  backgroundColor: (0, _styleHelpers.getColor)('common', 'white'),
  focus: {
    outlineSize: '3px',
    outlineColor: (0, _styleHelpers.getColor)('brand', 'lightest')
  },
  error: {
    borderColor: (0, _styleHelpers.getColor)('negative'),
    focus: {
      outlineColor: (0, _styleHelpers.getColor)('negative', 'lightest')
    }
  }
};
var inputBaseStyles = {
  defaultWidth: 300,
  padding: (0, _styledComponents.css)(["", " ", ""], (0, _styleHelpers.getSpacing)(3), (0, _styleHelpers.getSpacing)(4)),
  borderRadius: '8px',
  fontFamily: function fontFamily(props) {
    return props.theme.typography.base.fontFamily;
  },
  borderWidth: 1,
  filled: filledVariantStyle,
  outline: _objectSpread(_objectSpread({}, filledVariantStyle), {}, {
    backgroundColor: 'transparent'
  }),
  transitions: [['border-color', '0.3s'], ['box-shadow', '0.3s', 'ease-in-out']]
};
exports.inputBaseStyles = inputBaseStyles;